/**
 * Route for `landing-pages`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LandingPagesPage } from "../features/landing-pages/LandingPagesPage";

export const landingPagesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/landing-pages",
	component: LandingPagesPage,
});

export default landingPagesRoute;
